import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Dialog, DialogTitle, TextField, MenuItem, Box } from "@mui/material";
import './contact_form.scss';

const servizi = [
  "Vendita Prodotti",
  "Consulenza",
  "Agrofarmaci",
  "Sementi",
  "Concimi",
  "Altro"
];

const ContactForm = () => {
  const form = useRef<HTMLFormElement>(null);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [servizio, setServizio] = useState("");
  const [formData, setFormData] = useState({
    user_name: "",
    user_cognome: "",
    user_email: "",
    message: ""
  });
  const [errors, setErrors] = useState<{
    name?: boolean;
    cognome?: boolean;
    email?: boolean;
    message?: boolean;
    privacy?: boolean;
  }>({});
  const [openDialog, setOpenDialog] = useState(false);

  // Controlla se il form è valido per abilitare il bottone
  const isFormValid = () => {
    const { user_name, user_cognome, user_email, message } = formData;
    const isEmailValid = /\S+@\S+\.\S+/.test(user_email);
    return (
      user_name.trim() !== "" &&
      user_cognome.trim() !== "" &&
      user_email.trim() !== "" &&
      isEmailValid &&
      message.trim() !== "" &&
      privacyChecked
    );
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validateFields = () => {
    const { user_name, user_cognome, user_email, message } = formData;

    const newErrors = {
      name: !user_name.trim(),
      cognome: !user_cognome.trim(),
      email: !user_email.trim() || !/\S+@\S+\.\S+/.test(user_email),
      message: !message.trim(),
      privacy: !privacyChecked
    };

    setErrors(newErrors);
    return !Object.values(newErrors).some((err) => err);
  };

  const sendEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!form.current || !privacyChecked || !validateFields()) return;

    try {
        await emailjs.sendForm(
          "service_pyeiduv",
          "template_5nfo10e",
          form.current,
          "bht0nAgXw8CrVC7lM",
        );

        setOpenDialog(true);
        form.current.reset();
        setServizio("");
        setFormData({ user_name: "", user_cognome: "", user_email: "", message: "" });
        setPrivacyChecked(false);
        setErrors({});
    } catch (error) {
        console.error("Errore invio:", error);
    }
  };

  return (
    <div className="contact-form-wrapper">
      <form ref={form} onSubmit={sendEmail} noValidate className="contact-form">
        <Box className="form-row">
          <TextField
            fullWidth
            label="Nome"
            name="user_name"
            required
            value={formData.user_name}
            onChange={handleInputChange}
            error={errors.name}
            helperText={errors.name ? "Inserisci il tuo nome" : ""}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Cognome"
            name="user_cognome"
            required
            value={formData.user_cognome}
            onChange={handleInputChange}
            error={errors.cognome}
            helperText={errors.cognome ? "Inserisci il tuo cognome" : ""}
            variant="outlined"
          />
        </Box>

        <Box className="form-row">
          <TextField
            fullWidth
            label="Email"
            name="user_email"
            type="email"
            required
            value={formData.user_email}
            onChange={handleInputChange}
            error={errors.email}
            helperText={errors.email ? "Inserisci un'email valida" : ""}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Telefono"
            name="user_telefono"
            type="tel"
            variant="outlined"
          />
        </Box>

        <TextField
          fullWidth
          select
          label="Servizio richiesto"
          name="servizio"
          value={servizio}
          onChange={(e) => setServizio(e.target.value)}
          variant="outlined"
          className="form-select"
        >
          {servizi.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          label="Messaggio"
          name="message"
          multiline
          rows={4}
          required
          value={formData.message}
          onChange={handleInputChange}
          error={errors.message}
          helperText={errors.message ? "Inserisci un messaggio" : ""}
          variant="outlined"
        />

        <div className={`form-checkbox ${errors.privacy ? 'error' : ''}`}>
          <input
            type="checkbox"
            id="privacy"
            required
            checked={privacyChecked}
            onChange={(e) => setPrivacyChecked(e.target.checked)}
          />
          <label htmlFor="privacy">
            Ho letto e accettato la{" "}
            <a
              href="https://www.iubenda.com/privacy-policy/20127409"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span className="required">*</span>
          </label>
        </div>

        <button
          type="submit"
          className="submit-btn"
          disabled={!isFormValid()}
        >
          Invia
        </button>
      </form>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        slotProps={{
          paper: {
            style: {
              background: '#fff',
              border: '1px solid #056A0C',
              borderRadius: '16px',
              padding: '1rem'
            }
          }
        }}
      >
        <DialogTitle sx={{ color: '#056A0C', fontFamily: "'Poppins', sans-serif", textAlign: 'center' }}>
          Grazie! La tua richiesta è stata inviata
        </DialogTitle>
      </Dialog>
    </div>
  );
};

export default ContactForm;
